import React, { useState } from "react";
import { Input } from "antd";
import style from "./index.module.scss";
import { errorMessage } from "Utils/useRequest";
import ConfirmModal from "../ConfirmModal";
import { getCourseInfoByJoinInCode } from "API/invitationCode";
import useStorage from "Utils/useStorage";
import Config from "config";
import { ResultMessage } from "components/ResultMessage";

interface AddModalProps {
    onCancel: () => void;
    refreshData: () => void;
}

export default function AddModal({ onCancel, refreshData }: AddModalProps) {
    const [batch] = useStorage(
        "batch",
        localStorage.getItem("batch") || Config.DefaultBatch
    );

    const [code, setCode] = useState("");
    const [isSearch, setIsSearch] = useState(false);
    const [error, setError] = useState(""); // 错误状态
    const [courseInfo, setCourseInfo] = useState({
        batchNo: batch,
        courseNo: "",
        courseSeq: "",
        courseId: "",
        courseName: "",
        teacherName: ""
    });

    const handleSearch = async function () {
        if (!checkData()) return;
        try {
            const info = await getCourseInfoByJoinInCode(code?.trim());
            setCourseInfo({ ...courseInfo, ...info });
            setIsSearch(true);
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    };

    // 检查数据
    function checkData(): boolean {
        if (code?.trim().length === 0) {
            setError("请输入邀请码");
            return false;
        }
        return true;
    }

    function handleCancel() {
        setIsSearch(false);
        onCancel();
        setCode("");
    }

    function onOk() {
        refreshData();
        handleCancel();
    }

    return (
        <div className={style.root}>
            <div className={style.container}>
                <div className={style.top}>
                    <div className={style.title}>输入课程邀请码</div>
                    <Input
                        value={code}
                        onChange={e => setCode(e.target.value)}
                    />
                    <div className={style.error}>{error}</div>
                </div>

                <div className={style.footer}>
                    <div onClick={onCancel}>取消</div>
                    <div onClick={handleSearch}>查找</div>
                </div>
            </div>

            {isSearch && (
                <ConfirmModal
                    onCancel={handleCancel}
                    onOk={onOk}
                    courseInfo={courseInfo}
                    code={code}
                />
            )}
        </div>
    );
}
